import React, { useState } from 'react'

import {
  AbExperimentVariant,
  useStartsBoardingAbExperimentsMutation,
} from '../../remote/graphql'
import {
  ABExperiments,
  ABExperimentsProvider,
} from '../../providers/ABExperimentsProvider'
import { getAnalyticsObject } from '../../hooks/useAnalytics'

type StartABExperimentsProps = {
  children: React.ReactNode
}

export function StartABExperiments({ children }: StartABExperimentsProps) {
  const [currentABExperiments, setCurrentABExperiments] =
    useState<ABExperiments | null>(null)

  const [startsBoardingABExperiments] = useStartsBoardingAbExperimentsMutation({
    onCompleted: (data) => {
      const analytics = getAnalyticsObject()
      const { anonymousId, startedABExperiments } =
        data.startsBoardingABExperiments
      analytics?.setAnonymousId?.(anonymousId)
      const experiments = startedABExperiments
      const experimentsMap: ABExperiments = {}

      for (const experiment of experiments) {
        // If part of the treatment group, the flag id is set to true
        experimentsMap[experiment.abFlagId] =
          experiment.variant === AbExperimentVariant.Treatment
      }

      setCurrentABExperiments(experimentsMap)
    },
  })

  React.useEffect(() => {
    async function effect() {
      const analytics = getAnalyticsObject()
      // We wait for the analytics to be ready or 800ms at most
      await Promise.race([
        new Promise<void>((_, r) => setTimeout(r, 800)),
        new Promise<void>((r) => analytics?.ready(r)),
      ])
      const anonymousId = analytics?.getAnonymousId?.()
      startsBoardingABExperiments({
        variables: {
          anonymousId,
        },
      })
    }
    effect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ABExperimentsProvider value={currentABExperiments}>
      {children}
    </ABExperimentsProvider>
  )
}
